var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 421,
    height: 509.99999999999994,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: -1,
    width: 423,
    height: 512,
    id: "canvas_background",
    fill: "#ffffff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    id: "svg_23"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_24"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_25"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_26"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_27"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_28"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_29"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_30"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_31"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_32"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_33"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_34"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_35"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_36"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_37"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "svg_117"
  }, /*#__PURE__*/React.createElement("polygon", {
    stroke: "null",
    id: "svg_81",
    fill: "#f50057",
    points: "16.52743911743164,292.88782942295074 174.51699829101562,292.88782942295074 174.51699829101562,450.8773008584976 247.43527221679688,450.8773008584976 247.43527221679688,292.88782942295074 405.4249267578125,292.88782942295074 405.4249267578125,219.96944868564606 247.43527221679688,219.96944868564606 247.43527221679688,61.97982847690582 174.51699829101562,61.97982847690582 174.51699829101562,219.96944868564606 16.52743911743164,219.96944868564606 "
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    transform: "matrix(0.7595653926976128,0,0,0.7595653926976128,-701.3590743910969,-901.7249103337612) ",
    id: "svg_82"
  }, /*#__PURE__*/React.createElement("polygon", {
    stroke: "null",
    id: "svg_83",
    fill: "#3f51b5",
    points: "1352.048095703125,1602.6709554195404 1457.128173828125,1707.7510335445404 1457.128173828125,1602.6709554195404 "
  }), /*#__PURE__*/React.createElement("polygon", {
    stroke: "null",
    id: "svg_84",
    fill: "#3f51b5",
    points: "1279.0408935546875,1602.6709554195404 1457.128173828125,1780.7578694820404 1457.128173828125,1730.3980062007904 1329.401123046875,1602.6709554195404 "
  }), /*#__PURE__*/React.createElement("polygon", {
    stroke: "null",
    id: "svg_85",
    fill: "#3f51b5",
    points: "1409.692138671875,1780.7578694820404 1279.0408935546875,1650.094173192978 1279.0408935546875,1780.7578694820404 "
  })), /*#__PURE__*/React.createElement("polygon", {
    stroke: "null",
    id: "svg_86",
    fill: "#F0F0F0",
    points: "270.1561584472656,315.60865461826324 405.4249267578125,450.8773008584976 405.4249267578125,412.6257139444351 308.407958984375,315.60865461826324 "
  }), /*#__PURE__*/React.createElement("polygon", {
    stroke: "null",
    id: "svg_87",
    fill: "#f50057",
    points: "270.1561584472656,315.60865461826324 405.4249267578125,450.8773008584976 405.4249267578125,412.6257139444351 308.407958984375,315.60865461826324 "
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    transform: "matrix(0.7595653926976128,0,0,0.7595653926976128,-701.3590743910969,-901.7249103337612) ",
    id: "svg_88"
  }, /*#__PURE__*/React.createElement("polygon", {
    stroke: "null",
    id: "svg_89",
    fill: "#3f51b5",
    points: "1025.43017578125,1602.6709554195404 945.1280517578125,1682.9729573726654 945.1280517578125,1602.6709554195404 "
  }), /*#__PURE__*/React.createElement("polygon", {
    stroke: "null",
    id: "svg_90",
    fill: "#3f51b5",
    points: "1123.2120361328125,1625.3169515132904 1123.2120361328125,1780.7549397945404 967.7860107421875,1780.7549397945404 "
  })), /*#__PURE__*/React.createElement("polygon", {
    stroke: "null",
    id: "svg_91",
    fill: "#f50057",
    points: "113.54212951660156,315.61085188388824 16.52743911743164,412.62638533115387 16.52743911743164,450.8773008584976 16.52743911743164,450.8773008584976 151.79393005371094,315.61085188388824 "
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    transform: "matrix(0.7595653926976128,0,0,0.7595653926976128,-701.3590743910969,-901.7249103337612) ",
    id: "svg_92"
  }, /*#__PURE__*/React.createElement("polygon", {
    stroke: "null",
    id: "svg_93",
    fill: "#3f51b5",
    points: "1050.2078857421875,1446.8450276851654 945.1280517578125,1341.7649495601654 945.1280517578125,1446.8450276851654 "
  }), /*#__PURE__*/React.createElement("polygon", {
    stroke: "null",
    id: "svg_94",
    fill: "#3f51b5",
    points: "1123.215087890625,1446.8450276851654 945.1280517578125,1268.7581136226654 945.1280517578125,1319.1179769039154 1072.855224609375,1446.8450276851654 "
  }), /*#__PURE__*/React.createElement("polygon", {
    stroke: "null",
    id: "svg_95",
    fill: "#3f51b5",
    points: "992.5640258789062,1268.7581136226654 1123.215087890625,1399.421077489853 1123.215087890625,1268.7581136226654 "
  })), /*#__PURE__*/React.createElement("polygon", {
    stroke: "null",
    id: "svg_96",
    fill: "#F0F0F0",
    points: "151.79617309570312,197.248486161232 16.52743911743164,61.97982847690582 16.52743911743164,100.23153364658356 113.54443359375,197.248486161232 "
  }), /*#__PURE__*/React.createElement("polygon", {
    stroke: "null",
    id: "svg_97",
    fill: "#f50057",
    points: "151.79617309570312,197.248486161232 16.52743911743164,61.97982847690582 16.52743911743164,100.23153364658356 113.54443359375,197.248486161232 "
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    transform: "matrix(0.7595653926976128,0,0,0.7595653926976128,-701.3590743910969,-901.7249103337612) ",
    id: "svg_98"
  }, /*#__PURE__*/React.createElement("polygon", {
    stroke: "null",
    id: "svg_99",
    fill: "#3f51b5",
    points: "1376.8260498046875,1446.8450276851654 1457.128173828125,1366.5430257320404 1457.128173828125,1446.8450276851654 "
  }), /*#__PURE__*/React.createElement("polygon", {
    stroke: "null",
    id: "svg_100",
    fill: "#3f51b5",
    points: "1279.0439453125,1424.199153661728 1279.0439453125,1268.7610433101654 1434.47021484375,1268.7610433101654 "
  })), /*#__PURE__*/React.createElement("polygon", {
    stroke: "null",
    id: "svg_101",
    fill: "#f50057",
    points: "308.41015625,197.2462431192398 405.4249267578125,100.2307859659195 405.4249267578125,61.97982847690582 405.4249267578125,61.97982847690582 270.1585693359375,197.2462431192398 "
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    transform: "matrix(0.7595653926976128,0,0,0.7595653926976128,-701.3590743910969,-901.7249103337612) ",
    id: "svg_102"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    transform: "matrix(0.7595653926976128,0,0,0.7595653926976128,-701.3590743910969,-901.7249103337612) ",
    id: "svg_103"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    transform: "matrix(0.7595653926976128,0,0,0.7595653926976128,-701.3590743910969,-901.7249103337612) ",
    id: "svg_104"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    transform: "matrix(0.7595653926976128,0,0,0.7595653926976128,-701.3590743910969,-901.7249103337612) ",
    id: "svg_105"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    transform: "matrix(0.7595653926976128,0,0,0.7595653926976128,-701.3590743910969,-901.7249103337612) ",
    id: "svg_106"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    transform: "matrix(0.7595653926976128,0,0,0.7595653926976128,-701.3590743910969,-901.7249103337612) ",
    id: "svg_107"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    transform: "matrix(0.7595653926976128,0,0,0.7595653926976128,-701.3590743910969,-901.7249103337612) ",
    id: "svg_108"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    transform: "matrix(0.7595653926976128,0,0,0.7595653926976128,-701.3590743910969,-901.7249103337612) ",
    id: "svg_109"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    transform: "matrix(0.7595653926976128,0,0,0.7595653926976128,-701.3590743910969,-901.7249103337612) ",
    id: "svg_110"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    transform: "matrix(0.7595653926976128,0,0,0.7595653926976128,-701.3590743910969,-901.7249103337612) ",
    id: "svg_111"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    transform: "matrix(0.7595653926976128,0,0,0.7595653926976128,-701.3590743910969,-901.7249103337612) ",
    id: "svg_112"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    transform: "matrix(0.7595653926976128,0,0,0.7595653926976128,-701.3590743910969,-901.7249103337612) ",
    id: "svg_113"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    transform: "matrix(0.7595653926976128,0,0,0.7595653926976128,-701.3590743910969,-901.7249103337612) ",
    id: "svg_114"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    transform: "matrix(0.7595653926976128,0,0,0.7595653926976128,-701.3590743910969,-901.7249103337612) ",
    id: "svg_115"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    transform: "matrix(0.7595653926976128,0,0,0.7595653926976128,-701.3590743910969,-901.7249103337612) ",
    id: "svg_116"
  })), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    id: "svg_118",
    height: 490.47601,
    width: 73.333298,
    y: 13.095325,
    x: 174.785745,
    strokeWidth: "null",
    fill: "#f50057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_74",
    d: "m7.166774,99.381023c0,0 3.809522,90.476149 3.809522,90.476149c0,0 30.476177,120.952326 29.976066,120.618876c0.50011,0.33345 55.73818,99.381024 55.23807,99.047574c0.50011,0.33345 74.785791,66.047706 74.28568,65.714256c0.50011,0.33345 38.595331,24.142963 38.095221,23.809513c0.500111,0.33345 23.357243,-11.095116 22.857132,-11.428566c0.500111,0.33345 51.928659,-35.85701 51.428548,-36.19046c0.500111,0.33345 45.261995,-46.333195 45.261995,-46.333195c0,0 39.999982,-66.666636 39.499871,-67.000086c0.500111,0.33345 24.309624,-59.666523 23.809513,-59.999973c0.500111,0.33345 19.547721,-77.761753 19.04761,-78.095202c0.500111,0.33345 4.309633,-63.476045 3.809522,-63.809495c0.500111,0.33345 -5.214172,-39.666532 -5.214172,-39.666532c0,0 51.428548,-0.952381 50.928437,-1.28583c0.500111,0.33345 -1.40465,433.666585 -1.904761,433.333135c0.500111,0.33345 -486.166334,6.047733 -485.714064,5.714283c-0.45227,0.33345 -4.261792,-439.666349 -4.261792,-440.61873c0,-0.952381 39.047601,5.714283 39.047601,5.714283z",
    strokeOpacity: "null",
    strokeWidth: "null",
    stroke: "null",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_75",
    d: "m-0.452271,106.047687c0,0 6.666664,-8.571425 6.166554,-8.904874c0.50011,0.333449 101.452445,-24.428444 100.952334,-24.761894c0.500111,0.33345 57.642942,-24.428444 57.142832,-24.761893c0.50011,0.333449 30.023906,-28.237966 30.023906,-28.237966c0,0 14.285708,-4.761903 14.285708,-4.761903c0,0 67.619017,43.809504 67.118906,43.476055c0.500111,0.333449 75.738172,25.095342 75.238061,24.761893c0.500111,0.333449 58.595322,19.38106 58.095211,19.04761c0.500111,0.33345 35.73819,4.142972 35.23808,3.809522c0.50011,0.33345 -7.118934,-125.380779 -7.619045,-124.761847c0.500111,-0.618932 -464.261582,4.142971 -463.809311,4.761902c-0.452271,-0.618931 6.214393,116.523873 6.666663,116.190423c-0.45227,0.33345 20.500101,4.142972 20.500101,4.142972z",
    strokeOpacity: "null",
    strokeWidth: "null",
    stroke: "null",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_61",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_42",
    transform: "matrix(8.430736533089515,0,0,7.986111902321404,46.47669740744368,0) ",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m44.362771,11.229583c-10.77391,-2.1282 -19.34731,-4.9829 -24.941,-11.3548c-6.04591,6.8205 -14.31441,9.6514 -24.96921,11.3548c-0.5979,25.4383 8.6171,43.1886 24.9521,52.6452c16.617,-8.9291 25.8763,-25.9607 24.95811,-52.6452zm-24.92141,50.3316c-15.2201,-9.3021 -23.1498,-26.0668 -23.0069,-48.6266c8.2085,-1.425 16.50131,-3.809 22.9917,-10.1552c6.0122,5.7659 14.4762,8.3335 22.973,10.1005c0.4507,23.3979 -7.2678,39.7631 -22.9578,48.6813z",
    id: "svg_45",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_46",
    transform: "matrix(8.430736533089515,0,0,7.986111902321404,46.47669740744368,0) ",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_47",
    transform: "matrix(8.430736533089515,0,0,7.986111902321404,46.47669740744368,0) ",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_48",
    transform: "matrix(8.430736533089515,0,0,7.986111902321404,46.47669740744368,0) ",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_49",
    transform: "matrix(8.430736533089515,0,0,7.986111902321404,46.47669740744368,0) ",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_50",
    transform: "matrix(8.430736533089515,0,0,7.986111902321404,46.47669740744368,0) ",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_51",
    transform: "matrix(8.430736533089515,0,0,7.986111902321404,46.47669740744368,0) ",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_52",
    transform: "matrix(8.430736533089515,0,0,7.986111902321404,46.47669740744368,0) ",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_53",
    transform: "matrix(8.430736533089515,0,0,7.986111902321404,46.47669740744368,0) ",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_54",
    transform: "matrix(8.430736533089515,0,0,7.986111902321404,46.47669740744368,0) ",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_55",
    transform: "matrix(8.430736533089515,0,0,7.986111902321404,46.47669740744368,0) ",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_56",
    transform: "matrix(8.430736533089515,0,0,7.986111902321404,46.47669740744368,0) ",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_57",
    transform: "matrix(8.430736533089515,0,0,7.986111902321404,46.47669740744368,0) ",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_58",
    transform: "matrix(8.430736533089515,0,0,7.986111902321404,46.47669740744368,0) ",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_59",
    transform: "matrix(8.430736533089515,0,0,7.986111902321404,46.47669740744368,0) ",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_60",
    transform: "matrix(8.430736533089515,0,0,7.986111902321404,46.47669740744368,0) ",
    stroke: "null"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.4bffcd4b32c9b3bc0233f3033b702ed5.svg";
export { ForwardRef as ReactComponent };